(function () {
  var root = document.getElementById('KdcEmailPopup');
  if (!root) return;

  // 2026-10-10 (Émile): the popup offers a gift (−25 % on the upcoming beanie) for an email.
  // No more code, no countdown, nothing for the cart to read. See snippets/kdc-email-popup.liquid.
  var LS_SIGNED = 'kdcp-gift-signed';   // signed up → never opens by itself again
  var LS_CLOSED = 'kdcp3-closed-at';    // dismissed → quiet for snooze-days
  var DELAY_S = parseInt(root.getAttribute('data-delay') || '10', 10);
  if (!(DELAY_S >= 5)) DELAY_S = 10;
  var SNOOZE_MS = (parseInt(root.getAttribute('data-snooze-days') || '7', 10) || 7) * 24 * 3600 * 1000;
  var armed = false;

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var formState = root.querySelector('[data-kdcp-form-state]');
  var success = root.querySelector('[data-kdcp-success]');
  var bound = false;
  var lastFocus = null;

  function showSuccess() {
    if (formState) formState.hidden = true;
    if (success) success.hidden = false;
  }
  function showForm() {
    if (success) success.hidden = true;
    if (formState) formState.hidden = false;
  }

  function open(done) {
    if (done) showSuccess(); else showForm();
    lastFocus = document.activeElement;
    root.hidden = false;
    setJdgm(true);
    bind();
    var target = root.querySelector(done ? '[data-kdcp-success] .kdcp__buy' : '.kdcp__input');
    if (target) setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }

  function close() {
    root.hidden = true;
    setJdgm(false);
    if (lsGet(LS_SIGNED) !== '1') lsSet(LS_CLOSED, String(Date.now()));
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  // Judge.me's widget CSS (!important, own stacking context) draws over the popup, like it did over
  // the cart: hide every Judge.me element while the popup is open, restore on close.
  function setJdgm(hidden) {
    document.querySelectorAll('.jdgm-widget, [class^="jdgm-"], [class*=" jdgm-"]').forEach(function (el) {
      if (el.tagName === 'STYLE' || el.tagName === 'SCRIPT') return;
      if (hidden) el.style.setProperty('visibility', 'hidden', 'important');
      else el.style.removeProperty('visibility');
    });
  }

  function bind() {
    if (bound) return;
    bound = true;
    root.querySelectorAll('[data-kdcp-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
  }

  // Public: other scripts may open the popup on demand. code() stays for the cart script (always empty now).
  window.KDCPopup = { open: function () { open(lsGet(LS_SIGNED) === '1'); }, close: close, code: function () { return null; } };

  // After a successful Shopify customer-form post the page reloads with
  // customer_posted=true → remember it and show the thank-you state.
  var posted = /[?&]customer_posted=true/.test(location.search);
  if (posted) {
    lsSet(LS_SIGNED, '1');
    open(true);
    return;
  }

  // The form came back with an error (bad email): show it.
  if (root.querySelector('[data-kdcp-has-error]')) { open(false); return; }

  // Preview: append ?kdcp=test to any page URL to open it immediately.
  if (/[?&]kdcp=test/.test(location.search)) { open(false); return; }

  // Signed up already, closed recently, or on the cart page: never opens by itself.
  if (root.getAttribute('data-autoshow') === '0') return;
  if (lsGet(LS_SIGNED) === '1') return;
  var closedAt = parseInt(lsGet(LS_CLOSED) || '0', 10);
  if (closedAt && Date.now() - closedAt < SNOOZE_MS) return;

  var shown = false;
  function autoShow() {
    if (!armed || shown || !root.hidden) return;
    // Never on top of the open cart: wait until it closes.
    var drawer = document.querySelector('cart-drawer.active');
    if (drawer) { setTimeout(autoShow, 4000); return; }
    shown = true;
    open(false);
  }

  // 2026-10-07 (Émile): nothing opens by itself before the delay, exit intent included.
  setTimeout(function () { armed = true; autoShow(); }, DELAY_S * 1000);

  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) autoShow();
  });
  var deepestY = 0;
  var lastY = window.scrollY;
  var lastT = Date.now();
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    var now = Date.now();
    if (y > deepestY) deepestY = y;
    var dt = now - lastT;
    var dy = lastY - y;
    if (deepestY > window.innerHeight * 1.5 && dy > 0 && dt > 0 && dy / dt > 1.2 && y < window.innerHeight * 0.4) autoShow();
    lastY = y;
    lastT = now;
  }, { passive: true });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && deepestY > window.innerHeight * 1.5) autoShow();
  });
})();
